import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { format } from 'date-fns'
import { CloudX } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { getStars } from '../helpers'
import { getCuttedString } from '../../BuildingDashboard/BuildingEssentials/helpers'
import Icon from '../../Icons'

const Reviews = ({ reviewsData, loading }) => {
  const { t } = useTranslation(['building-analytics'])

  const getStarsWithText = (review) => {
    return (
      <div className="review-bottom-line-wrapper">
        {getStars(review.stars)}
        <span className="review-type-text">
          {getCuttedString(review.survey.templateName, 28, 25)}
        </span>
        <Link className="redirect-button" to={`/dashboard/survey/${review.survey.id}`}>
          {t('building-analytics:common.view')}
          <Icon
            styles={{ width: '20px', paddingLeft: '5px' }}
            viewBox="0 0 20 20"
            icon={'arrowRight'}
            svgProps={{ stroke: '#646464', strokeLinecap: 'round', strokeLinejoin: 'round' }}
            fill="none"
          />
        </Link>
      </div>
    )
  }

  const getReviews = () => {
    return (
      <div className="reviews-list-wrapper">
        {reviewsData.map((review) => (
          <div key={review.id} className="review-wrapper">
            <div className="review-header">
              <h3>
                {review.user.firstName} {review.user.lastName}
              </h3>
              <span className="review-unit">
                {' '}
                {t('building-analytics:reviews.unit', { apartment: review.user.apartment })}
              </span>
              <span className="review-date">{format(review.updatedAt, 'MM/dd/yyyy')}</span>
            </div>
            <p className="review-text">{review.comment}</p>
            {getStarsWithText(review)}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="reviews">
      <div className="reviews__header">
        <div className="title-with-icon">
          <Icon styles={{ width: '22px', height: '22px' }} viewBox="0 0 24 24" icon="reviews" />
          <h3>{t('building-analytics:reviews.title')}</h3>
        </div>
        <p>{t('building-analytics:reviews.mostRecent')}</p>
      </div>
      {loading ? (
        <div className="loading">
          <h3>....</h3>
          <h3>{t('building-analytics:common.loading')}</h3>
        </div>
      ) : (
        <div className="reviews__main-block">
          {reviewsData && reviewsData.length ? (
            getReviews()
          ) : (
            <div className="no-data">
              <CloudX size={24} />
              <h3>{t('building-analytics:common.noDataTitle')}</h3>
              <p>{t('building-analytics:common.noDataDescription')}</p>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

Reviews.propTypes = {
  reviewsData: PropTypes.array,
  loading: PropTypes.bool,
}
export default Reviews
